import React from "react";



const Delivery = ({ width, height, color }) => {

  return (
    <svg
      width={width || 80}
      height={ height || 80}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M78.7535 0.536423C79.7356 1.2503 80.1373 2.20214 79.9588 3.39194L68.5312 71.9242C68.3824 72.7868 67.9063 73.4561 67.1028 73.932C66.6862 74.17 66.2249 74.289 65.719 74.289C65.3916 74.289 65.0345 74.2146 64.6477 74.0659L41.123 64.4731L27.8206 79.063C27.2849 79.6877 26.5856 80 25.7226 80C25.3059 80 24.9637 79.9405 24.6959 79.8215C24.1304 79.6133 23.6841 79.2638 23.3567 78.773C23.0294 78.2822 22.8657 77.7394 22.8657 77.1445V56.9774L1.79613 48.3663C0.695035 47.9498 0.0998501 47.1319 0.0105724 45.9123C-0.0787054 44.7523 0.397443 43.8748 1.43902 43.2799L75.7181 0.447188C76.7597 -0.177456 77.7715 -0.147711 78.7535 0.536423ZM63.487 67.4179L73.3522 8.38908L9.3401 45.2877L24.3388 51.4002L62.8621 22.8897L41.5247 58.4498L63.487 67.4179Z"
        fill={color || "#BEAA62"}
      />
    </svg>
  );
};

export default Delivery;
